export default {
  language_selector: {
    label: 'Alege o limbă',
  },
  nav_items: {
    home: 'Acasă',
    menu: 'Meniu',
    locations: 'Locații',
    store_info: 'Info magazin',
    rewards: 'Recompense',
  },
};
